import React from 'react';
import svgPaths from './svgPaths';
import PropTypes from 'prop-types';

/**
 * UsersIcon Component
 *
 * Icon representing users/team members
 *
 * @param {boolean} isEnabled - Whether the icon should be in enabled state (colored) or disabled (gray)
 */
const UsersIcon = ({ isEnabled = false }) => {
  const fillColor = isEnabled ? '#2A4490' : '#D9D9D9';
  const strokeColor = isEnabled ? 'black' : '#B9B9B9';

  return (
    <div className="relative size-full min-w-0 min-h-0" data-name="Users icon">
      <svg
        className="block size-full object-contain"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 132.989 123.984"
      >
        <g id="Users icon">
          <path d={svgPaths.p296bcf70} fill={fillColor} id="Ellipse 464" stroke={strokeColor} />
          <g id="Subtract">
            <mask fill="white" id="path-2-inside-1_10_1213">
              <path d={svgPaths.pdfb9d80} />
            </mask>
            <path d={svgPaths.pdfb9d80} fill={fillColor} />
            <path d={svgPaths.p27882200} fill={strokeColor} mask="url(#path-2-inside-1_10_1213)" />
          </g>
          <path d={svgPaths.p19454180} fill="white" id="Ellipse 465" stroke={strokeColor} />
          <path d={svgPaths.p24797500} fill="white" id="Vector 18" stroke={strokeColor} />
        </g>
      </svg>
    </div>
  );
};

UsersIcon.propTypes = {
  isEnabled: PropTypes.bool,
};

export default UsersIcon;
